<template>
    <div class="container">
        <div class="row justify-content-center align-items-center" style="height: 99vh;">
            <div class="col-md-7 text-center">
                <h2 class="text-muted">Um momento você será redirecionado<span ref="loadingDots"></span></h2>
                <span class="text-danger">* Usuários do aplicativo devem sair manualmente.</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            intervalId: null,
            dotCount: 1,
            maxDots: 3
        };
    },
    mounted() {
        this.intervalId = setInterval(this.updateDots, 500);

        window.onload = function() {
            console.log('load')
            window.parent.postMessage('UsuárioDesconectado', '*');
        };

    },
    beforeDestroy() {
        clearInterval(this.intervalId);
    },
    methods: {
        updateDots() {
            this.dotCount = (this.dotCount % this.maxDots) + 1;
            this.renderDots();
        },
        renderDots() {
            let dots = '';
            for (let i = 0; i < this.dotCount; i++) {
                dots += ' .';
            }
            this.$refs.loadingDots.innerText = dots;
        }
    }
};
</script>
